<template>
    <div class="test" style="width: 100%;height: 100%;">
      <VEmojiPicker @select="onSelectEmoji" />
      <!-- <div >
        <div slot="content">
          <el-tabs tab-position="left" @tab-click="tabClick">
            <el-tab-pane>
              <div class="img-div" style="overflow: auto; height: 100%">
                <i
                  class="emoji"
                  v-for="(item1, index1) in faceList[tabIndex].iconArr"
                  :key="index1"
                  @click="clickEmoji(item1.icon)"
                  style="cursor: pointer"
                >
                  {{ item1.icon }}
                </i>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
      <i class="iconfont icon-xiaolian" title="表情" @click="bqb"></i> -->
    </div>
  </template>
   
  <script>
  import { emojiArr } from "./emojiArr"; //引入js文件
   
  export default {
    name: "test",
    data() {
      return {
        faceList: emojiArr,
        tabIndex: 0, //表情包的类型索引
        show: false,
        input: "",
      };
    },
    methods: {
      // 点击表情包
      onSelectEmoji(emoji) {
      // console.log(emoji.data,111111111111111111);
      this.$emit('changeEmoji',emoji.data)
      
    },
      clickEmoji(val) {
        this.$emit('changeEmoji',val)
        // // 获取textarea输入框元素节点
        // let ele = document.querySelector("#textarea");
        // // 获取光标
        // let cursor = ele.selectionStart;
        // // 设置文本内容
        // ele.setRangeText(val);
        // // 移动光标并聚焦
        // ele.selectionStart = cursor + 2;
        // ele.focus();
        // // 使文本输入框的内容等于当前的值
        // this.input = ele.value;
        // this.show = false;
      },
    },
  };
  </script>
   
   
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style lang="scss" scoped>
  .bqb {
    background-color: #ffffff;
    width: 100%;
    height: 100%;
  }
  </style>